<template>
  <div class="rightSection">
    <slot name="quickFilter"></slot>
    <div class="searchBox ">
      <img
        src="../../assets/img/new-symbol/iconSearch.svg"
        alt=""
      >
      <el-input
        class="input-border__bottom input-border__radius__0"
        v-model="keyword_"
        size="medium"
        placeholder="Nhập từ khoá"
        @keydown.enter.exact.native="$emit('simpleSearch', keyword_)"
      />
    </div>
    <slot name="advance"></slot>
  </div>
</template>

<script>
export default {
  name: 'search',
  props: ['keyword'],
  data () {
    return {
      keyword_: ''
    }
  },
  created () {
    this.keyword_ = this.keyword;
  },
  watch: {
    keyword (newValue) {
      this.keyword_ = newValue;
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/common/noAdvSearch.vue